import { createContext } from 'react';
import { ACTIVE, TEACHER_TABLE_EMAIL_COL, TEACHER_TABLE_NAME_COL, TEACHER_TABLE_NUM_COURSES_COL, TEACHER_TABLE_STATUS_COL } from '../i18n/keyConstants';

const selectedFilters = { name: '', email: '', isRemoved: '' };

const tableColumnExtensions = [
    { columnName: 'numCourses', width: 150, align: 'right' },
];

const defaultColumns = [
    {
        title: TEACHER_TABLE_NAME_COL,
        name: "name"
    },
    {
        title: TEACHER_TABLE_EMAIL_COL,
        name: "email"
    },
    {
        title: TEACHER_TABLE_STATUS_COL,
        name: "isActive"
    },
    {
        title: TEACHER_TABLE_NUM_COURSES_COL,
        name: "numCourses"
    },
];

const defaultHiddenColumns = [];

export const initialState = {
    filters: [{ columnName: 'isActive', operation: 'equal', value: 'true' }],
    selectedFilters: selectedFilters,
    defaultFilters: [],
    selectedTeacherStatus: [{ label: ACTIVE, value: 'true' }],
    hiddenColumns: defaultHiddenColumns,
    tableSize: 0,
    pageSize: 25,
    currentPage: 1,
    direction: 'asc',
    sortInfo: {},
    columnName: 'name',
    columns: defaultColumns,
    isResettingFilters: false,
    tableColumnExtensions,
    teachers: [],
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                tableSize: action.totalRows,
                teachers: action.teachers,
            };
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
            };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [{ columnName: 'isActive', operation: 'equal', value: 'true' }],
                defaultFilters: [{ columnName: 'isActive', operation: 'equal', value: 'true' }],
                selectedTeacherStatus: [{ label: 'Aktiva', value: 'true' }],
                currentPage: 1,
                pageSize: 25,
                isResettingFilters: true,
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                isResettingFilters: false,
            };
        case 'SELECTED_FILTERS':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
            };
        case 'FILTERS_AND_SELECTED_FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.columnNameVal }),
            };
        case 'PAGESIZE':
            return {
                ...state,
                pageSize: action.payload,
            };
        case 'CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload,
            };
        case 'HIDDEN_COLUMNS_AND_CUSTOM_COLS':
            return {
                ...state,
                hiddenColumns: action.hiddenColumns,
                showCustomCols: action.showCustomCols,
            };
        case 'RESET_HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: defaultHiddenColumns,
                showCustomCols: false,
            };
        case 'SELECTED_TEACHER_STATUS':
            return {
                ...state,
                selectedTeacherStatus: action.payload,
            };
        case 'SELECTED_FILTERS_AND_FILTERS_RESET':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
                isResettingFilters: false,
            };
        case 'SORT_INFO':
            return {
                ...state,
                sortInfo: action.sortInfo,
                columnName: action.columnName,
                direction: action.direction,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
